import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as siteActions from '../../actions/siteActions';
import ReactCSSTransitionReplace from 'react-css-transition-replace';
import { ScrollToPlugin } from 'gsap';
import _shuffle from 'lodash/shuffle';
import { browserHistory, Link } from 'react-router';
import ClientsBlock from '../clientsBlock';
import BlogBlock from '../blogBlock';


class AboutPage extends React.Component {
	constructor() {
		super();
		this.state = {
			animated: false,
			selected: '',
			pageSlug: false
		};
		this.showContent = this.showContent.bind(this);
		this.showTeamMember = this.showTeamMember.bind(this);
	}
	componentWillMount() {
		window.scrollTo(0, 0);
	}
	componentDidMount() {
		this.props.actions.showNavBar(true);
		this.props.actions.showMenu(true);

		if (this.props.site.posts.length < 4) {
			this.props.actions.loadBlogPosts(3, 1);
		}
	}
	componentWillUnmount() {
		this.props.actions.clearState();
	}
	showTeamMember(member, index) {
		return (<div key={index} className="col-md-3 col-xs-12 col-sm-6 team-member">
			<p className="job-title">{member.job_title}</p>
			<h3>{member.name}</h3>
			<img src={member.image} />
			<p className="description" dangerouslySetInnerHTML={{ __html: member.description }}></p>
		</div>);
	}
	showContent() {
		switch (this.props.route.path) {
			case 'about/ethos':
				return <div key={Math.random()} dangerouslySetInnerHTML={{ __html: this.props.site.aboutPage.acf ? this.props.site.aboutPage.acf.ethos : '' }} className="text-content"></div>;
			case 'about/history':
				return <div key={Math.random()} dangerouslySetInnerHTML={{ __html: this.props.site.aboutPage.acf ? this.props.site.aboutPage.acf.history : '' }} className="text-content"></div>;
			case 'about/team':
				return (<div key={Math.random()} className="team-members">
					{this.props.site.aboutPage.acf ? _shuffle(this.props.site.aboutPage.acf.team).map(this.showTeamMember) : ''}

				</div>);
			case 'about/careers':
				return <div key={Math.random()} dangerouslySetInnerHTML={{ __html: this.props.site.aboutPage.acf ? this.props.site.aboutPage.acf.careers_info : '' }} className="text-content"></div>;
			default:
				return <div key={Math.random()} className="text-content" dangerouslySetInnerHTML={{ __html: this.props.site.aboutPage.content ? this.props.site.aboutPage.content.rendered : '' }}></div>;
		}
	}
	render() {
		return (
			<div className="services-page animated fadeIn portfolio-page about-page">
				<div className="portfolio-top">
					<div className="container">
						<div className="row">
							<h1><span>/</span> About</h1>
							<div className="dash-separator"></div>
							<ul className="page-links">
								<li><Link to="/about" activeClassName="active"><span>/</span> Overview</Link></li>
								{/*<li><Link to="/about/ethos" activeClassName="active"><span>/</span> Ethos</Link></li>*/}
								{/*<li><Link to="/about/history" activeClassName="active"><span>/</span> History</Link></li>*/}
								{/* <li><Link to="/about/team" activeClassName="active"><span>/</span> Team</Link></li> */}
								<li><Link to="/about/careers" activeClassName="active"><span>/</span> Careers</Link></li>
							</ul>
						</div>
					</div>
				</div>
				<div className="page-content">
					<div className="container">
						<div className="row">
							<ReactCSSTransitionReplace transitionName="cross-fade" transitionEnterTimeout={300} transitionLeaveTimeout={300}>{this.showContent()}
							</ReactCSSTransitionReplace>
						</div>
					</div>
				</div>
				<BlogBlock posts={this.props.site.posts} maxPosts={3} loading={this.props.site.loadingPosts} />
				<ClientsBlock clients={this.props.site.selectedClients} />
			</div>
		);
	}
}

function mapStateToProps(state, ownProps) {
	return {
		site: state.site
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(siteActions, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(AboutPage);



/** WEBPACK FOOTER **
 ** ./src/js/components/about/aboutPage.js
 **/